import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { z } from 'zod'
import { Center, Spinner } from '@chakra-ui/react'
import { authenticatedRoute } from '../_authenticated'
import { publicWithTabsRoute } from '../_publicWithTabs'

const ProfilePage = lazy(() => import('@/pages/profile').then(m => ({ default: m.ProfilePage })))
const EditProfile = lazy(() => import('@/pages/profile/EditProfile'))

function ProfilePageWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <ProfilePage />
    </Suspense>
  )
}

function EditProfileWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <EditProfile />
    </Suspense>
  )
}

const profileSearchSchema = z.object({
  showTasteInsights: z.boolean().optional(),
})

export const profileIndexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/profile',
  validateSearch: profileSearchSchema,
  component: ProfilePageWrapper,
})

export const profileEditRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/profile/edit',
  component: EditProfileWrapper,
})

// Public route for viewing other users' profiles (for SEO/sharing)
export const profileUserRoute = createRoute({
  getParentRoute: () => publicWithTabsRoute,
  path: '/profile/$userId',
  parseParams: ({ userId }) => ({ userId: Number(userId) }),
  stringifyParams: ({ userId }) => ({ userId: String(userId) }),
  validateSearch: profileSearchSchema,
  component: ProfilePageWrapper,
})
